import React, { FC, useCallback, useEffect, useState } from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { useRouter } from 'next/router'
import { authSelectors } from '@ucheba/store/auth'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Description } from '@ucheba/ui/components/Description/desktop'
import { Button } from '@ucheba/ui/components/Button/desktop'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import { feedbacksSelectors } from '@ucheba/store/feedbacks'
import { stringifyUrl } from '@ucheba/utils/helpers/router'
import { scrollTo } from '@ucheba/utils/helpers/components'
import CommunicationForm from '../../../../../../../../components/UsersCommunication/desktop/CommunicationForm'
import Illustration from './illustration.png'
import { EFormType } from '../../../../../../../../components/UsersCommunication/types'
import { IEmptyList } from '../../../types'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 24px;
  border-radius: 8px;

  background-color: ${sv.color.navy};
  background-image: url(${Illustration});
  background-repeat: no-repeat;
  background-position: right;
  background-size: contain;
`

const Content = styled.div`
  max-width: 65%;
  margin-bottom: 16px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const ButtonStyled = styled(Button)`
  width: 174px;
`

const EmptyList: FC<IEmptyList> = (props) => {
  const { type = 'institution', id } = props
  const [isOpen, setIsOpen] = useState(false)
  const { push, asPath, query, replace } = useRouter()
  const isAuth = useSelector(authSelectors.isValidToken)
  const feedbacks = useSelector(feedbacksSelectors.entity)

  const onDialogClose = useCallback((): void => {
    setIsOpen(false)
  }, [])

  const handleOpenDialog = useCallback((): void => {
    if (!isAuth) {
      push(
        stringifyUrl(`/auth`, {
          update: {
            redirect: stringifyUrl(asPath, {
              update: {
                feedbacks: 1,
              },
            }),
          },
        }),
        undefined,
        {}
      )

      return
    }

    setIsOpen(true)
  }, [isAuth, push, asPath])

  useEffect(() => {
    if (query.feedbacks) {
      setIsOpen(true)

      scrollTo('feedbacks')

      replace(
        stringifyUrl(asPath, {
          update: {
            ...query,
          },
          exclude: ['feedbacks'],
        }),
        undefined,
        { shallow: true, scroll: false }
      )
    }
  }, [])

  return (
    <>
      <Wrapper id='feedbacks'>
        <Content>
          <Heading color='white' h2='Оставьте отзыв' spacing='xxsmall' />

          <Description
            color='white'
            description={[
              'Учились здесь? Оставьте отзыв, и, может быть, это поможет другим в выборе. Кроме этого, из ваших оценок формируется наш рейтинг.',
            ]}
          />
        </Content>

        <ButtonStyled color='gold' onClick={handleOpenDialog}>
          Оставить отзыв
        </ButtonStyled>
      </Wrapper>

      <CommunicationForm
        parentId={null}
        onClose={onDialogClose}
        formType={EFormType.feedbacks}
        isOpen={isOpen}
        rootId={id}
        list={feedbacks?.items || []}
        type={type}
      />
    </>
  )
}

export default EmptyList
